/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult
 */
export interface JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult
     */
    tokenID?: string;
}

/**
 * Check if a given object implements the JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult interface.
 */
export function instanceOfJumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResultFromJSON(json: any): JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult {
    return JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResultFromJSONTyped(json, false);
}

export function JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenID': !exists(json, 'tokenID') ? undefined : json['tokenID'],
    };
}

export function JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResultToJSON(value?: JumboPostapiintegrationaccountsPostAPIIntegrationAccountsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tokenID': value.tokenID,
    };
}

